import script from "./SocialNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialNavbar.vue?vue&type=script&setup=true&lang=js"

import "./SocialNavbar.vue?vue&type=style&index=0&id=b1408ec0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1408ec0"]])

export default __exports__